import { api } from './client';
import type { CastSpellRequest, CastSpellResult, Kingdom } from '../types/magic';

// Backend wraps CastSpellResult in a response object with province data
interface CastSpellResponse {
  result: CastSpellResult;
  province: unknown;
}

export async function castSpell(
  worldId: string,
  provinceId: string,
  request: CastSpellRequest
): Promise<CastSpellResult> {
  const response = await api.post<CastSpellResponse>(
    `/api/worlds/${worldId}/provinces/${provinceId}/cast`,
    request
  );
  if (response.error || !response.data) {
    throw new Error(response.error || 'Failed to cast spell');
  }
  return response.data.result;
}

export async function getKingdom(worldId: string, kingdomId: string): Promise<Kingdom> {
  const response = await api.get<Kingdom>(`/api/worlds/${worldId}/kingdoms/${kingdomId}`);
  if (response.error || !response.data) {
    throw new Error(response.error || 'Failed to load kingdom');
  }
  return response.data;
}
